const havenomobile = 1002 
const success = 200


export default {
    havenomobile,
    success
}

